import { GeoAutocompleteOption, SearchForm } from '../types';

// Добавил постфикс v3, чтобы не было пересечений с уже имеющейся у пользователей историей.
const searchHistoryKey = 'OTT/bus/searchHistory/v3';
const departureHistoryKey = 'OTT/bus/departureHistory/v3';
const destinationHistoryKey = 'OTT/bus/destinationHistory/v3';

const SEARCH_HISTORY_LIMIT = 3;
const GEO_POINT_HISTORY_LIMIT = 10;

const getSearchHistoryByKey = (key: string) => {
  const currentHistoryJSON = localStorage.getItem(key);
  const currentHistory = currentHistoryJSON ? JSON.parse(currentHistoryJSON) : null;

  return currentHistory;
};

export const getDepartureHistory = () => getSearchHistoryByKey(departureHistoryKey)?.val || [];
export const getDestinationHistory = () => getSearchHistoryByKey(destinationHistoryKey)?.val || [];
export const getSearchHistory = () => {
  clearDeprecatedSearchHistory();
  return getSearchHistoryByKey(searchHistoryKey)?.val || [];
};

const clearDeprecatedSearchHistory = () => {
  const currentHistory = getSearchHistoryByKey(searchHistoryKey)?.val || [];
  if (currentHistory.length > 0) {
    const dateNow = new Date().setUTCHours(0, 0, 0, 0);
    const filteredHistory = currentHistory.filter((historyItem: SearchForm<string>) => {
      return dateNow <= new Date(historyItem.date).setUTCHours(0, 0, 0, 0);
    });

    localStorage.setItem(searchHistoryKey, JSON.stringify({ val: filteredHistory }));
  }
};

const saveSearchHistoryByKey = ({
  key,
  itemToSave,
  checkIfItemExistsFunc,
  limit,
  shouldUpdateExistingHistoryItem,
}: {
  key: string;
  itemToSave: SearchForm<string> | GeoAutocompleteOption;
  checkIfItemExistsFunc: (item: SearchForm<string> | GeoAutocompleteOption) => boolean;
  limit: number;
  shouldUpdateExistingHistoryItem?: boolean;
}) => {
  const currentHistory = getSearchHistoryByKey(key);

  if (!currentHistory) {
    localStorage.setItem(key, JSON.stringify({ val: [itemToSave] }));

    return;
  }

  if (!currentHistory.val.some(checkIfItemExistsFunc)) {
    currentHistory.val.unshift(itemToSave);
  }

  if (currentHistory.val.length > limit) {
    currentHistory.val.pop();
  }

  if (shouldUpdateExistingHistoryItem) {
    const itemToUpdateIndex = currentHistory.val.findIndex(checkIfItemExistsFunc);
    if (itemToUpdateIndex !== -1) {
      currentHistory.val[itemToUpdateIndex] = itemToSave;
      const itemToMove = currentHistory.val.splice(itemToUpdateIndex, 1)[0];
      currentHistory.val.unshift(itemToMove);
    }
  }

  localStorage.setItem(key, JSON.stringify(currentHistory));
};

type DateType = string;
const saveSearchHistory = (submittedData: SearchForm<DateType>) => {
  saveSearchHistoryByKey({
    key: departureHistoryKey,
    itemToSave: submittedData.departureOption,
    checkIfItemExistsFunc: (item) =>
      (item as GeoAutocompleteOption).value === submittedData.departureOption.value,
    limit: GEO_POINT_HISTORY_LIMIT,
  });

  saveSearchHistoryByKey({
    key: destinationHistoryKey,
    itemToSave: submittedData.destinationOption,
    checkIfItemExistsFunc: (item) =>
      (item as GeoAutocompleteOption).value === submittedData.destinationOption.value,
    limit: GEO_POINT_HISTORY_LIMIT,
  });

  saveSearchHistoryByKey({
    key: searchHistoryKey,
    itemToSave: submittedData,
    checkIfItemExistsFunc: (item) => {
      const historyItem = item as SearchForm<string>;

      return (
        historyItem.departureOption.value === submittedData.departureOption.value &&
        historyItem.destinationOption.value === submittedData.destinationOption.value &&
        historyItem.date === submittedData.date
      );
    },
    shouldUpdateExistingHistoryItem: true,
    limit: SEARCH_HISTORY_LIMIT,
  });
};

export default saveSearchHistory;
